import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";


export class committeeReviewer extends EntityDto implements IEntityDto {
  Reviewer_Id:string;
  Committee_Id: string;
  CommitteeName: string;
  Emp_Ref_Id: string;
  EmployeeName:string
  DepartmentName: string;
  DesignationName:string
  Designation_Id: string;
  Department_Id:string
  IsActive: boolean;
constructor() {
    super();
    this.Reviewer_Id = '00000000-0000-0000-0000-000000000000';
    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.CommitteeName = '';
    this.Emp_Ref_Id='';
    this.DepartmentName='';
    this.DesignationName='';
    this.Designation_Id='';
    this.Department_Id='';
    this.IsActive = true;
    this.EmployeeName='';
    this.EntityMetaData = [
      { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Committee is required' },
      { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
   
     

    ];
  }
}